export const model = process.env.REACT_APP_MODEL;
export const apiKey = process.env.REACT_APP_API_KEY;
export const bulbs = {
  lamp1: {
    name: process.env.REACT_APP_BULB_LAMP1_NAME,
    device: process.env.REACT_APP_BULB_LAMP1_DEVICE,
  },
  lamp2: {
    name: process.env.REACT_APP_BULB_LAMP2_NAME,
    device: process.env.REACT_APP_BULB_LAMP2_DEVICE,
  },
  lamp3: {
    name: process.env.REACT_APP_BULB_LAMP3_NAME,
    device: process.env.REACT_APP_BULB_LAMP3_DEVICE,
  },
};
